import { Lightning } from "@lightningjs/sdk";
import { gridHeight, gridWidth } from "../../services/grid.service";

export default class Button extends Lightning.Component {
  static _template() {
    return {
      flex: {},
      Background: {
        flex: {},
        texture: Lightning.Tools.getRoundRect(
          4 * gridWidth,
          1 * gridHeight,
          0,
          3,
          0xfff4f4f4,
          true,
          0x00ffffff
        ),
        Label: {
          y: 0.58 * gridHeight,
          mount: 0.5,
          text: { fontFace: "Roboto-Regular", fontSize: 24 },
        },
      },
    };
  }

  set label(buttonLabel) {
    this._label = buttonLabel;

    this.tag("Label").patch({
      text: { text: this._label },
    });
  }

  set labelX(buttonLabelX) {
    this.tag("Label").patch({
      x: buttonLabelX,
    });
  }

  set width(buttonWidth) {
    this.buttonWidth = buttonWidth;
    this.patch({
      Background: {
        texture: Lightning.Tools.getRoundRect(
          this.buttonWidth,
          1 * gridHeight,
          0,
          3,
          0xfff4f4f4,
          true,
          0x00f4f4f4
        ),
      },
    });
  }

  _focus() {
    this.patch({
      Background: {
        texture: Lightning.Tools.getRoundRect(
          this.buttonWidth,
          1 * gridHeight,
          0,
          3,
          0xfff4f4f4,
          true,
          0xfff4f4f4
        ),
        Label: {
          smooth: { color: 0xff000000 },
          text: { fontFace: "Roboto-Bold" },
        },
      },
    });
  }

  _unfocus() {
    this.patch({
      Background: {
        texture: Lightning.Tools.getRoundRect(
          this.buttonWidth,
          1 * gridHeight,
          0,
          3,
          0xfff4f4f4,
          true,
          0x00ffffff
        ),
        Label: {
          smooth: { color: 0xfff4f4f4 },
          text: { fontFace: "Roboto-Regular" },
        },
      },
    });
  }
}
